module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer039"
    }
  }, [_c('p', {
    staticClass: "author"
  }, [_vm._v("Amanda has been in education for over 30 years, teaching in Japan, Tokyo, Shanghai, Hong Kong, Singapore and now Ireland. Throughout all the changes that a transient lifestyle presents, she has built a career based on her passion for supporting young children with additional needs.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Amanda’s first book is set where she resides and works now, within a quaint village Primary School in beautiful rural farmland in County Mayo, Ireland. It is the people, animals and affinity for the natural elements that surround her which inspired her to write ")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Desse’s Big Day")]), _c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(". In particular, she identifies with the vulnerability of children starting school and wanted to dedicate a book to them where being different is celebrated.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Amanda has an Arts Degree from Winchester School of Art and has always tried to bring a creative flair to both her occupational and private life. She lives with her husband John, daughter Lizzy, and a spoilt cat named Pandora, who loves to eat very strong mature cheese.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Amanda hopes to write about Pandora as the star of future publications!")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics- _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Cover3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright--Amanda-Duffy-2024-"
  }, [_vm._v("Copyright ©Amanda Duffy 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Illustrated by Nadica Mitevska")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The right of ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Amanda Duffy")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" and ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Nadica Mitevska")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" to be identified as author and illustrator of this work has been asserted by them in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("A CIP catalogue record for this title is available from the British Library.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("ISBN 9781035841127 (Paperback)")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("ISBN 9781035841141 (ePub e-book)")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("ISBN 9781035841134 (Audiobook)")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("www.austinmacauley.com")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("First Published 2024")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Austin Macauley Publishers Ltd®")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("1 Canada Square ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Canary Wharf ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("London")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("E14 5AA")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("This is dedicated to all the students who I have taught over the years, especially the gorgeously creative Jesse. His love of dinosaurs, dragons and all things magical inspired me to write "), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Desse’s Big Day.")]), _vm._v(" Keep reaching for the stars!")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("To my darling daughter Lizzy, who has flown the nest and begun to carve out her own career. Your curious mind, positivity, and kindness leaves me in total awe. I love being in fits of laughter with my best friend.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("To my husband, John, for your love and for always supporting my dreams.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("This wouldn’t be possible without my dear mumma, Bea, who listens patiently to my next idea and seems to be my biggest fan. Mums are very cool angels.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thank you to all at Austin Macauley Publishers for your vision and dedication in making my little message come to life for children.")])]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("A short time ago, on a farm known as Flaggons,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_1_print_(1).jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("Lived a worried soon-to-be Infant school Dragon,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_2_print_(2).jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("His mum prayed for")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-11",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("him not to worry,")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_3_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("Dad waved goodbye from a tractor spreading slurry,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-5",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_4_print_2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("Mum finally said, “Be a good Draggo Raptor.”")]), _vm._v(" "), _c('p', {
    staticClass: "image-center",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-6",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_5_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("Desse climbed the school bus to start a new chapter,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-7",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_6_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("The bus was full of chattering, excited")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-11",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("little dragons,")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-8",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_7_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("Desse sat with tears filling his eyes, can you imagine?")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-9",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_8_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("The teacher greeted everyone with a friendly puff of smoke,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_9_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("Little Desse held back tears, trying not to choke,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_10_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("He noticed the other dragons could already breathe fire,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_11_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("Desse looked on, full of desire,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_12_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("A big dragon, Red Smoke, blew a magnificent furnace,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_13_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("Desse could only manage a puff in earnest,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-11",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_14_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics- _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-12",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_15_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("He went on to feel toothless and useless,")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-11",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("And add to the pot, shoeless and clueless,")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-13",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_16_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics- _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-12",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_17_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("At lunchtime, the others ate frogs wrapped in snakes,")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-11",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Desse quietly munched on his mum’s homemade bakes,")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-14",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-9",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_18_print.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("Desse’s skin was smooth with a plum shade of purple,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_19_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("While the others had bumpy skin, green like a turtle,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-14",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_20_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("The other dragons started to shirk, laugh and snigger,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_21_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("You may make fun, but that doesn’t make you bigger!")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_22_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("During PE it was a competition about flying,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_23_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("Desse stretched his wings, but to fly, he’d be lying.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_24_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("It’s OK to be different with a certain mystique,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_25_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("He remembers the teacher adding, it makes you unique,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_26_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("Desse was a sensitive little soul,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_27_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("Making good friends was a major goal,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_28_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("He had a special trick up his sleeve,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_29_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("Desse could read and write, would you believe!")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_30_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("By the end of the week, he was feeling much better,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_31_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("Desse was helping the others sound out their letters,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_32_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("The other dragons helped Desse breathe fire,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_33_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("But he accidentally melted the school gate, made of wire,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_34_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-15"
  }, [_vm._v("Every raptor broke into laughter that was ear bursting loud,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_35_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("Making friends made Desse feel warm, fuzzy and proud,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-15",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_36_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("Today, Desse doesn’t worry, get tearful or feel shy,")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_37_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text ParaOverride-10"
  }, [_vm._v("He joins in, has fun, and you guessed it, can fly!")]), _vm._v(" "), _c('p', {
    staticClass: "image-center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-16",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/page_38_print.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "THE-END"
  }, [_vm._v("THE END")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2220314a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled-1.vue
// module id = 57
// module chunks = 0